orders-basic-approvals
  .wrap(each="{scope in opts.stamps}")
    orders-approvals-stamp(tag-scope="{scope}")
  script(type="typescript").
    this.mixin('base');
  style(scoped).
    :scope {
      display: flex;
    }
    .wrap {
      margin-left: -1px;
    }
